import React from 'react'
import _get from 'lodash/get'
import _isEqual from 'lodash/isEqual'
import { getPerfomanceData } from '../../../../_common/core/http_services'
import LoadingBar from '../../../_library/LoadingBar'
import AddOnBreakdownComponent from './AddOnBreakdownComponent'
import { addOnBreakdownDataAdapter } from '../../../../_common/core/http_services/adapters'

export default class PerformanceAddOnBreakdown extends React.PureComponent {
  constructor(props) {
    super(props)

    this.initialData = null
    this.state = {
      isLoadingAddOnBreakdownData: true,
    }
  }

  componentDidUpdate(prevProps) {
    const { event } = this.props

    if (_get(event, 'selectedCurrency') !== _get(prevProps.event, 'selectedCurrency')) {
      this.fetchAddOnBreakdown()
    }
  }

  componentDidMount() {
    this.fetchAddOnBreakdown()
    this.fetchAddOnBreakdownId = setInterval(async () => {
      this.fetchAddOnBreakdown()
    }, 10 * 1000)
  }

  componentWillUnmount() {
    this.isUnmounted = true
    clearInterval(this.fetchAddOnBreakdownId)
  }

  fetchAddOnBreakdown = async () => {
    const { event } = this.props
    const section = 'add_on_breakdown'
    try {
      const res = await getPerfomanceData(event.id, section, {
        currency: event.selectedCurrency ?? null,
      })
      const addOnBreakdownData = _get(res, section) || []
      const adaptedAddOnBreakdownData = addOnBreakdownDataAdapter(addOnBreakdownData)
      if (!_isEqual(adaptedAddOnBreakdownData, this.initialData)) {
        this.initialData = adaptedAddOnBreakdownData
        this.handleResponse(adaptedAddOnBreakdownData)
      }
    } catch (error) {
      this.handleResponse(null, error)
    }
  }

  handleResponse = (addOnBreakdownData, error) => {
    const { isLoadingAddOnBreakdownData } = this.state

    if (this.isUnmounted) return
    isLoadingAddOnBreakdownData &&
      this.setState({
        isLoadingAddOnBreakdownData: false,
      })

    if (error) {
      console.error(error)
    } else {
      this.setState({ addOnBreakdownData })
    }
  }

  render() {
    const { event, tickets, user } = this.props
    const { isLoadingAddOnBreakdownData, addOnBreakdownData } = this.state

    return isLoadingAddOnBreakdownData ? (
      <LoadingBar title={`Hold tight! We're getting your event's sales details...`} />
    ) : (
      <AddOnBreakdownComponent event={event} tickets={tickets} data={addOnBreakdownData} user={user} />
    )
  }
}
